import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppService, BASE_URL_CRUD, BASE_URL_SSO, BASE_URL_MESSAGE } from '../app.service';
import { Observable } from 'rxjs/Observable';
import { User, UserAuth } from '../models/user.model';

@Injectable()
export class UserService extends AppService {

  constructor(http: HttpClient) {
    super(http);
  }

  getUsersByAdministration(administrationId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/users`;
    return this.get(this.endpoint);
  }

  getAll(communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/communities/${communityId}/list`;
    return this.get(this.endpoint);
  }

  getUserById(userId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}`;
    return this.get(this.endpoint);
  }

  getCommunityByUser(userId: Number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}/communities`;
    return this.get(this.endpoint);
  }

  getAdministrationByUser(userId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}/administrations`;
    return this.get(this.endpoint);
  }

  addToAdministration(user: UserAuth, administration_id: Number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administration_id}/users/${user.userid}`;
    return this.post(this.endpoint, {});
  }

  changeOwner(unitId: Number, data): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/units/${unitId}/change-owner`;
    return this.post(this.endpoint, data);
  }

  getUsersByRealm(communityId: Number, realm: String): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/community/${communityId}/realm/${realm}`;
    return this.get(this.endpoint);
  }

  getUsersSso(userId: number): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/users/ids/${userId}`;
    return this.get(this.endpoint);
  }

  getUsersBySector(communityId: number, sectorId: number): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user/sector/${sectorId}`;
    return this.get(this.endpoint);
  }

  create(data: any) {
    this.endpoint = `${BASE_URL_SSO}/users`;
    return this.post(this.endpoint, data);
  }

  update(userId: number, data: any) {
    this.endpoint = `${BASE_URL_SSO}/users`;
    return this.put(this.endpoint, data, 'text');
  }

  deleteUser(userId: number, administrationId: number) {
    this.endpoint = `${BASE_URL_CRUD}/administrations/${administrationId}/user/${userId}`;
    return this.delete(this.endpoint, 'text');
  }

  postCommunityByUser(userId, communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}/communities`;
    return this.post(this.endpoint, { community_id: communityId }, 'text');
  }

  removeCommunityByUser(userId, communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/users/${userId}/communities/${communityId}`;
    return this.delete(this.endpoint, 'text');
  }

  getTcelUsers(communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/tcel-users`;
    return this.get(this.endpoint);
  }

  postUserTcel(communityId, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user-with-roles`;
    return this.post(this.endpoint, data);
  }

  gettUserTcel(communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user-realm-tcel`;
    return this.get(this.endpoint);
  }

  getUserListTcel(communityId: number, dataTablesParameters?: any): Observable<any> {
    let query = '';
    if (dataTablesParameters) {
      const start = dataTablesParameters.start ? dataTablesParameters.start : 0;
      const length = dataTablesParameters.length ? dataTablesParameters.length : null;
      const findValue = dataTablesParameters.search.value ? dataTablesParameters.search.value : '';
      query = `?draw=${start}&length=${length}&value=${findValue}`;
    }
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/tcel-user-list${query}`;
    return this.get(this.endpoint);
  }

  gettUserTcelById(userId): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/tcel/users/${userId}`;
    return this.get(this.endpoint);
  }

  puttUserTcel(communityId, userId, data: any): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user-realm-tcel/${userId}`;
    return this.put(this.endpoint, data);
  }

  deleteUserTcel(communityId, userId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user-realm-tcel/${userId}`;
    return this.delete(this.endpoint, 'text');
  }

  getUserTcel(communityId, role?): Observable<any> {
    let query = '';
    if (role) {
      query = `?role=${role}`;
    }
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/user-realm-tcel${query}`;
    return this.get(this.endpoint);
  }

  postSendNotification(data): Observable<any> {
    this.endpoint = `${BASE_URL_MESSAGE}/notification-user`;
    return this.post(this.endpoint, data);
  }

  getPropertiesUsers(communityId): Observable<any> {
    this.endpoint = `${BASE_URL_CRUD}/communities/${communityId}/properties-users`;
    return this.get(this.endpoint);
  }

  getCurrentUserInfo(): Observable<any> {
    this.endpoint = `${BASE_URL_SSO}/users/me`;
    return this.get(this.endpoint);
  }
}




// WEBPACK FOOTER //
// ./src/app/services/user.service.ts